import React, { useState } from "react";

const TestLink: React.FC = () => {
  const [param1] = useState("test" + Math.random().toString(36).substring(2, 6));
  const [param2] = useState("demo" + Math.random().toString(36).substring(2, 8));
  const [linkCreated, setLinkCreated] = useState(false);
  const [error, setError] = useState("");

  const createTestLink = async () => {
    try {
      // Call the REST API endpoint to create a link
      const response = await fetch('/api/setup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          templateId: 'test-template-001',
          maxUses: 10,
          ttlSeconds: 604800, // 7 days
          tags: ['test', 'local'],
          payload: {
            name: 'Test Pass',
            value: '100'
          }
        })
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Link created:', data);
        setLinkCreated(true);
        setError("");
      } else {
        throw new Error('Failed to create link');
      }
    } catch (err: any) {
      setError(err.message || "Failed to create link");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow p-6">
        <h1 className="text-2xl font-bold mb-4">Test Link Creator</h1>
        
        <div className="space-y-4">
          <div className="p-4 bg-blue-50 rounded-md">
            <p className="text-sm text-blue-800">
              This creates a test link for local development. 
              Make sure your sandbox is running!
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Test Param1</label>
            <input 
              type="text" 
              value={param1} 
              readOnly 
              className="mt-1 block w-full rounded-md border border-gray-300 bg-gray-50 px-3 py-2"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700">Test Param2</label>
            <input 
              type="text" 
              value={param2} 
              readOnly 
              className="mt-1 block w-full rounded-md border border-gray-300 bg-gray-50 px-3 py-2"
            />
          </div>

          <button
            onClick={createTestLink}
            disabled={linkCreated}
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 disabled:bg-gray-400"
          >
            {linkCreated ? "Link Created!" : "Create Test Link"}
          </button>

          {linkCreated && (
            <div className="mt-4 p-4 bg-green-50 rounded-md">
              <p className="text-green-800 font-medium">Success! Test your link:</p>
              <div className="mt-2 space-y-2">
                <div>
                  <p className="text-sm text-gray-600">Local preview:</p>
                  <a 
                    href={`/preview/${param1}/${param2}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline break-all"
                  >
                    http://localhost:3001/preview/{param1}/{param2}
                  </a>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Short URL (when deployed):</p>
                  <span className="text-gray-800 font-mono">
                    https://add2wallet.link/{param1}/{param2}
                  </span>
                </div>
              </div>
            </div>
          )}

          {error && (
            <div className="mt-4 p-4 bg-red-50 rounded-md">
              <p className="text-red-800">{error}</p>
              <p className="text-sm text-red-600 mt-2">
                Note: This requires the API to be running. 
                For now, you can manually test with these URLs:
              </p>
              <div className="mt-2 font-mono text-xs">
                /preview/{param1}/{param2}
              </div>
            </div>
          )}

          <div className="mt-6 pt-6 border-t">
            <h3 className="font-medium mb-2">Manual Testing:</h3>
            <p className="text-sm text-gray-600">
              You can also test directly by visiting:
            </p>
            <code className="block mt-2 p-2 bg-gray-100 rounded text-sm">
              http://localhost:3001/preview/test123/demo5678
            </code>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestLink;